// extracted by mini-css-extract-plugin
module.exports =  {"box":"rating_box-module_box_f667d","hidden":"rating_box-module_hidden_cc871"};